<template>
        <b-card no-body>
          <b-card-body>
              <b-row>
                  <b-col md="6">
                      <h3>Visualizar Dados e atendimentos à Beneficiária</h3>
                      <b-card-body>
                          <b-row>
                              <p><b>Nome:</b> {{beneficiaria.nome}}</p>
                          </b-row>
                        <!-- <b-row>
                            <p><b>CPF:</b> {{beneficiaria.cpf}}</p>
                        </b-row> -->
                        <!-- <b-row>
                            <p><b>RG + Órgão de Expedição:</b> {{dadosPessoais.rg}}</p>
                        </b-row> -->
                        <b-row>
                            <p><b>Data de nascimento:</b> {{dadosPessoais.dataNascimento}}</p>
                        </b-row>
                          <!-- <b-row>
                              <span v-if="dadosPessoais.sexo === 'M'">
                                 <p><b>Sexo:</b> Masculino</p>
                              </span>
                              <span v-if="dadosPessoais.sexo === 'F'">
                                  <p><b>Sexo:</b> Feminino</p>
                              </span>
                          </b-row> -->
                          <!-- <b-row>
                              <p> <b>Nº NIS:</b> {{dadosPessoais.nis}}</p>
                          </b-row> -->
                          <b-row>
                              <span v-if="dadosPessoais.gestante_mae === 'G'">
                                 <p><b>Gestante ou mãe:</b> Gestante</p>
                              </span>
                              <span v-if="dadosPessoais.gestante_mae === 'M'">
                                  <p><b>Gestante ou mãe:</b> Mãe</p>
                              </span>
                          </b-row>
                          <b-row>
                              <span v-if="dadosPessoais.estado_civil === 'C'">
                                 <p><b>Estado Civíl:</b> Casado(a)</p>
                              </span>
                              <span v-if="dadosPessoais.estado_civil === 'S'">
                                  <p><b>Estado Civíl:</b> Solteira(a)</p>
                              </span>
                              <span v-if="dadosPessoais.estado_civil === 'D'">
                                  <p><b>Estado Civíl:</b> Divorciado(a)</p>
                              </span>
                              <span v-if="dadosPessoais.estado_civil === 'V'">
                                  <p><b>Estado Civíl:</b> Viúvo(a)</p>
                              </span>
                          </b-row>
                          <!-- <b-row>
                              <span v-if="dadosPessoais.escolaridade === 'FI'">
                                <p><b>Escolaridade:</b> Fundamental - Incompleto</p>
                              </span>
                              <span v-if="dadosPessoais.escolaridade === 'FC'">
                                 <p><b>Escolaridade:</b> Fundamental - Completo</p>
                              </span>
                              <span v-if="dadosPessoais.escolaridade === 'MI'">
                                 <p><b>Escolaridade:</b> Médio - Incompleto</p>
                              </span>
                              <span v-if="dadosPessoais.escolaridade === 'MC'">
                                 <p><b>Escolaridade:</b> Médio - Completo</p>
                              </span>
                              <span v-if="dadosPessoais.escolaridade === 'SI'">
                                 <p><b>Escolaridade:</b> Superior - Incompleto</p>
                              </span>
                              <span v-if="dadosPessoais.escolaridade === 'SC'">
                                 <p><b>Escolaridade:</b> Superior - Completo</p>
                              </span>
                              <span v-if="dadosPessoais.escolaridade === 'PI'">
                                 <p><b>Escolaridade:</b> Pós-graduação - Incompleto</p>
                              </span>
                              <span v-if="dadosPessoais.escolaridade === 'PC'">
                                 <p><b>Escolaridade:</b> Pós-graduação - Completo</p>
                              </span>
                              <span v-if="dadosPessoais.escolaridade === 'MI'">
                                 <p><b>Escolaridade:</b> Mestrado - Incompleto</p>
                              </span>
                              <span v-if="dadosPessoais.escolaridade === 'MC'">
                                 <p><b>Escolaridade:</b> Mestrado - Completo</p>
                              </span>
                              <span v-if="dadosPessoais.escolaridade === 'DI'">
                                 <p><b>Escolaridade:</b> Doutorado - Incompleto</p>
                              </span>
                              <span v-if="dadosPessoais.escolaridade === 'DC'">
                                 <p><b>Escolaridade:</b> Doutorado - Incompleto</p>
                              </span>
                          </b-row> -->
                          <!-- <b-row>
                              <p><b>Telefone:</b> {{dadosPessoais.telefone}}</p>
                          </b-row> -->
                          <b-row>
                              <p><b>UF:</b> {{dadosPessoais.sigla}}</p>
                          </b-row>
                          <b-row>
                              <p><b>Município:</b> {{dadosPessoais.cidade}}</p>
                          </b-row>
                          <!-- <b-row>
                              <p><b>Bairro:</b> {{dadosPessoais.bairro}}</p>
                          </b-row>
                          <b-row>
                              <p><b>Endereço:</b> {{dadosPessoais.endereco}}</p>
                          </b-row>
                          <b-row>
                              <p><b>Complemento:</b> {{dadosPessoais.complemento}}</p>
                          </b-row>
                          <b-row>
                              <p><b>Número:</b> {{dadosPessoais.numero}}</p>
                          </b-row>
                          <b-row>
                              <p><b>CEP:</b> {{dadosPessoais.cep}}</p>
                          </b-row> -->
                          <b-row>
                              <p><b>Profisão/Ocupação:</b> {{dadosPessoais.profissao}}</p>
                          </b-row>
                          <!-- <b-row>
                              <p><b>E-mail:</b> {{beneficiaria.email}}</p>
                          </b-row> -->
                            <b-row>
                               <b-button  @click="desfazerVinculo" variant="primary"><i class="fa fa-check">&nbsp;</i> Eu quero me desvincular da beneficiária</b-button>
                          </b-row>

                      </b-card-body>
                  </b-col>
                  <b-col md="6">
                      <h3>Atendimentos</h3>
                      <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Encontro</th>
                              <th scope="col">Dia</th>
                              <th scope="col">Realizado</th>
                              <th scope="col">Avaliação</th>
                            </tr>
                          </thead>
                          <tbody v-if="atendimentos.data !== undefined">
                            <tr v-for="atend in atendimentos.data" :key="atend.id">
                              <td>{{atend.ordem}}º Encontro</td>
                              <td>{{atend.data_encontro | formatDateToBR}} - {{horariotext.substring(0, horariotext.length - 1)}}h</td>
                              <td>
                                  <span v-if="atend.realizado == 'SIM'">Sim</span>
                                  <span v-if="atend.realizado == 'CANCELADO'">Cancelado</span>
                                  <span v-if="atend.realizado == 'NAO' && atend.situacao == 'PENDENTE'"> - </span>
                                  <span v-if="atend.realizado == 'NAO' && atend.situacao != 'PENDENTE'"> Não </span>
                              </td>
                              <td style="width: 15%">
                                  <a v-if="permiteConfirmacao(atend.data_encontro) && atend.realizado == 'NAO' && atend.situacao == 'PENDENTE'" class="btn btn-sm btn-secondary action" title="Confirmar Encontro" @click="confirmarEncontro(atend.id)">
                                     <i class="fa fa-check"></i>
                                  </a>
                                  <a v-if="atend.realizado == 'SIM' && !atend.respostas.length" class="btn btn-sm btn-secondary action" title="Avaliar Encontro" @click="$router.push('/formulario/' + atend.id + '/avaliacao-encontro')">
                                     <i class="fa fa-file-text-o"></i>
                                  </a>
                                  <a v-if="permiteConfirmacao(atend.data_encontro) && atend.realizado == 'NAO' && atend.situacao == 'PENDENTE'" class="btn btn-sm btn-secondary action" title="Encontro não realizado" @click="encontroNaoRealizado(atend.id)">
                                     <i class="fa fa-times"></i>
                                  </a>
                                  <a v-if="permiteAvaliarCancelamento(atend.data_encontro, atend)" class="btn btn-sm btn-secondary action" title="Avaliar Justificativa" @click="avaliarCancelamento(atend.id, atend.justificativa_beneficiaria, atend.imagem_anexada)">
                                     <i class="fa fa-bars"></i>
                                  </a>
                                  <a v-if="permiteCancelamento(atend.data_encontro, atend)" class="btn btn-sm btn-secondary action" title="Cancelar com antecedência" @click="cancelarAntecedencia(atend.id)">
                                     <i class="fa fa-power-off"></i>
                                  </a>
                                  <!-- <a v-if="permiteAnexarDocumento(atend.data_encontro, atend) && atend.realizado == 'CANCELADO' && atend.situacao == 'PENDENTE'" class="btn btn-sm btn-secondary action" title="Anexar documento da Justificativa do Cancelamento" @click="anexarDocumentoJustificativa(atend.id)">
                                     <i class="fa fa-file-image-o"></i>
                                  </a> -->
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                           <tr class="action">
                             <td colspan="7">Nenhum registro de atendimentos...</td>
                           </tr>
                          </tbody>
                         </table>
                      <pagination :beneficiaria="$route.params.id" v-show="atendimentos.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"></pagination>
                  </b-col>
              </b-row>
        </b-card-body>
        <b-modal title="Avaliar justificativa de cancelamento" :hide-footer="true" v-model="modalAvaliarJustificativa">
            <b-card-body>
               <b-form>
                  <b-col cols="12">
                      <b-col class="row justify-content-center">
                         <div class="image-preview" v-if="imagemJustificativa">
                            <img class="preview" :src="imagemJustificativa">
                         </div>
                      </b-col>
                  </b-col>
                  <b-col cols="12" v-if="justificativaVoluntario" :disabled="true">
                    <br>
                    <b-form-textarea readonly id="textarea" v-model="justificativa" rows="3" max-rows="6"></b-form-textarea>
                  </b-col>
                   <b-col cols="12" v-if="rejeitar">
                    <br>
                    <b-form-textarea :state="justificativaVoluntarioState" id="textarea" placeholder="Justifique a razão da rejeição..." v-model="justificativaVoluntario" rows="3" max-rows="6"></b-form-textarea>
                  </b-col>
               </b-form>
           </b-card-body>
           <b-card-footer class="p-12">

                <b-button @click="aprovarJustificativa" variant="primary"><i class="fa fa-plus-square">&nbsp;</i> Aprovar</b-button>
            <b-button @click="rejeitarJustificativa" variant="secondary"><i class="fa fa-minus-square">&nbsp;</i> Rejeitar</b-button>
        </b-card-footer>
        </b-modal>
        <b-modal title="Cancelar com antecedência" :hide-footer="true" v-model="modalCancelarAntecedencia">
            <b-card-body>
               <b-form>
                 <b-col sm="12">
                    <b-form-group label="Justificativa:">
                        <b-form-select v-model="cancelar.justificativa" :state="cancelar.justificativaState" :options="justificativas" class="mb-3">
                            <option selected :value="null"> Selecione</option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" v-if="cancelar.mostrarMotivo">
                    <b-form-group label="Não poderei comparecer pois...">
                        <b-form-select v-model="cancelar.motivo" :state="cancelar.motivoState" :options="motivos" class="mb-3">
                            <option selected :value="null"> Selecione</option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                      <b-col sm="12" v-if="cancelar.mostrarMotivo">
                          <label>Anexar Documento:</label>
                             <span class="icon-info" v-b-popover.hover.top="'Permitidos apenas imagens'" title="Informação"></span>
                           <b-form-group label-for="nome-input" invalid-feedback="Documento é obrigatório">
                           <b-form-file browse-text="Selecione" placeholder="Selecione o documento" v-on:change="uploadDocumento"></b-form-file>
                             <b-form-invalid-feedback id="input1LiveFeedback3">Documento é obrigatório.</b-form-invalid-feedback>
                          </b-form-group>
                     </b-col>
                <b-col sm="12" v-if="cancelar.mostrarMotivoTexto">
                    <b-form-group label="Justifique:">
                        <b-form-textarea id="textarea" :state="cancelar.motivoTextoState" v-model="cancelar.motivoTexto" rows="3" max-rows="6"></b-form-textarea>
                    </b-form-group>
                </b-col>
               </b-form>
           </b-card-body>
           <b-card-footer class="p-12">
             <span v-if="!loadingCancelar">
                <b-button @click="efetivarCancelamento" variant="primary"><i class="fa fa-check">&nbsp;</i> Enviar</b-button>
             </span>
              <span v-else>
                  <b-button variant="primary" class="btn" disabled>
                      <b-spinner small type="grow"></b-spinner>Enviando...
                  </b-button>
             </span>
            <b-button @click="limparForm" variant="secondary"><i class="fa fa-times">&nbsp;</i> Cancelar</b-button>
        </b-card-footer>
        </b-modal>
        <b-modal title="Documento de justificativa" :hide-footer="true" v-model="modalDocumentoJustificativa">
            <b-card-body>
               <b-form>
                      <b-col sm="12">
                          <label>Anexar Documento:</label>
                             <span class="icon-info" v-b-popover.hover.top="'Permitidos apenas imagens'" title="Informação"></span>
                           <b-form-group label-for="nome-input" invalid-feedback="Documento é obrigatório">
                           <b-form-file :state="cancelar.documentoAtrState" browse-text="Selecione" placeholder="Selecione o documento" v-on:change="uploadDocumentoAtr"></b-form-file>
                             <b-form-invalid-feedback id="input1LiveFeedback3">Documento é obrigatório.</b-form-invalid-feedback>
                          </b-form-group>
                     </b-col>
               </b-form>
           </b-card-body>
           <b-card-footer class="p-12">
            <b-button @click="enviarDocumentoAtr" variant="primary"><i class="fa fa-check">&nbsp;</i> Enviar</b-button>
            <b-button @click="modalDocumentoJustificativa = false" variant="secondary"><i class="fa fa-times">&nbsp;</i> Cancelar</b-button>
        </b-card-footer>
        </b-modal>
         <b-modal title="Desvincular de uma Beneficiária" :hide-footer="true" hide-header-close v-model="modalDesfazerVinculo">
            <b-card-body>
                 <b-form>
                   <p>
                     Você tem certeza de que deseja se desvincular da Beneficiária {{beneficiaria.nome}}? Às vezes, com diálogo, conseguimos resolver situações desafiadoras. Sugerimos que, inicialmente, converse com o(a) seu/sua Tutor(a) para tentar resolver a situação. Lembre-se que a desvinculação pode desmotivar a permanência dessa Beneficiária no Projeto Mães Unidas.
                   </p>
                    <b-col sm="12">
                      <b-form-group label="Marque um motivo abaixo...">
                        <b-form-select v-model="cancelar.motivoRemocao" :state="cancelar.motivoRemocaoState" :options="motivosRemocao" class="mb-3">
                            <option selected :value="null"> Selecione</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" v-if="cancelar.mostrarMotivoRemocaoTexto">
                        <b-form-group label="Justifique:">
                            <b-form-textarea id="textarea" :state="cancelar.motivoRemocaoTextoState" v-model="cancelar.motivoRemocaoTexto" rows="3" max-rows="6"></b-form-textarea>
                        </b-form-group>
                    </b-col>
               </b-form>
           </b-card-body>
           <b-card-footer class="p-12">
                <b-button @click="efetivarRemocao" variant="primary"><i class="fa fa-check">&nbsp;</i> Quero me desvincular</b-button>
                <b-button variant="secondary" @click="fecharModal"><i class="fa fa-times">&nbsp;</i> Cancelar</b-button>
           </b-card-footer>
        </b-modal>
      </b-card>
</template>

<script>
import SessionStorage from '@/services/session-storage'
import Pagination from '@/components/shared/PaginationVoluntario'
import miniToastr from 'mini-toastr'
import Vue from 'vue'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'V') {
      this.$store.dispatch('getMinhaBeneficiaria', this.$route.params.id)
    } else {
      this.$router.push('/')
    }
    this.$store.dispatch('buscarJustificativas')
    this.$store.dispatch('buscarMotivos')
    this.$store.dispatch('buscarMotivosRemocaoVinculo')
  },
  watch: {
    'atendimentos': function () {
      if (this.atendimentos.data.length) {
        this.horariotext = this.atendimentos.data[0].horarios[0].horario
      }
    },
    'beneficiaria.dados_pessoais': function () {
      this.dadosPessoais.rg = this.beneficiaria.dados_pessoais.rg + ' ' + this.beneficiaria.dados_pessoais.orgao_expeditor
      this.dadosPessoais.dataNascimento = this.beneficiaria.dados_pessoais.data_nascimento
      this.dadosPessoais.sexo = this.beneficiaria.dados_pessoais.sexo
      this.dadosPessoais.nis = this.beneficiaria.dados_pessoais.nis
      this.dadosPessoais.gestante_mae = this.beneficiaria.dados_pessoais.gestante_mae
      this.dadosPessoais.estado_civil = this.beneficiaria.dados_pessoais.estado_civil
      this.dadosPessoais.escolaridade = this.beneficiaria.dados_pessoais.escolaridade
      this.dadosPessoais.telefone = this.beneficiaria.dados_pessoais.telefone
      this.dadosPessoais.sigla = this.beneficiaria.dados_pessoais.cidade.estado.sigla
      this.dadosPessoais.cidade = this.beneficiaria.dados_pessoais.cidade.cidade
      this.dadosPessoais.bairro = this.beneficiaria.dados_pessoais.bairro
      this.dadosPessoais.endereco = this.beneficiaria.dados_pessoais.endereco
      this.dadosPessoais.complemento = this.beneficiaria.dados_pessoais.complemento
      this.dadosPessoais.numero = this.beneficiaria.dados_pessoais.numero
      this.dadosPessoais.cep = this.beneficiaria.dados_pessoais.cep
      this.dadosPessoais.profissao = this.beneficiaria.dados_pessoais.profissao
    },
    'cancelar.justificativa': function () {
      if (this.cancelar.justificativa !== null) {
        this.cancelar.motivo = null
        this.cancelar.motivoState = null
        this.cancelar.motivoTexto = null
        this.cancelar.motivoTextoState = null

        if (this.cancelar.justificativa === 'BCJ') {
          this.cancelar.mostrarMotivo = true
        }
        if (this.cancelar.justificativa === 'BSJ') {
          this.cancelar.mostrarMotivo = false
          this.cancelar.mostrarMotivoTexto = false
        }
        if (this.cancelar.justificativa === 'VCJ') {
          this.cancelar.mostrarMotivo = true
        }
        if (this.cancelar.justificativa === 'VSJ') {
          this.cancelar.mostrarMotivo = false
          this.cancelar.mostrarMotivoTexto = false
        }
      }
    },
    'cancelar.motivo': function () {
      this.cancelar.motivoTexto = null
      this.cancelar.motivoTextoState = null

      if (this.cancelar.motivo !== null) {
        if (parseInt(this.cancelar.motivo) === 4) {
          this.cancelar.mostrarMotivoTexto = true
        } else {
          this.cancelar.mostrarMotivoTexto = false
        }
      }
    },
    'cancelar.motivoRemocao': function () {
      this.cancelar.motivoRemocaoTexto = null
      this.cancelar.motivoRemocaoTextoState = null

      if (this.cancelar.motivoRemocao !== null) {
        if (parseInt(this.cancelar.motivoRemocao) === 3) {
          this.cancelar.mostrarMotivoRemocaoTexto = true
        } else {
          this.cancelar.mostrarMotivoRemocaoTexto = false
        }
      }
    }
  },
  data () {
    return {
      horariotext: '',
      dadosPessoais: {
        rg: null,
        dataNascimento: null,
        sexo: null,
        nis: null,
        gestante_mae: null,
        estado_civil: null,
        escolaridade: null,
        telefone: null,
        sigla: null,
        cidade: null,
        bairro: null,
        endereco: null,
        complemento: null,
        numero: null,
        cep: null,
        profissao: null
      },
      loadingCancelar: false,
      loadingNaoComparecer: false,
      meusAtendimentos: [],
      totalPorPagina: 10,
      resource: 'atendimento',
      usuarioCorrente: parseInt(SessionStorage.get('usuario')),
      modalAvaliarJustificativa: false,
      modalCancelarAntecedencia: false,
      modalDocumentoJustificativa: false,
      modalDesfazerVinculo: false,
      id: null,
      imagemJustificativa: null,
      justificativa: null,
      justificativaVoluntario: null,
      justificativaVoluntarioState: null,
      rejeitar: false,
      cancelar: {
        justificativa: null,
        justificativaState: null,
        motivo: null,
        motivoRemocao: null,
        motivoState: null,
        motivoRemocaoState: null,
        mostrarMotivoTexto: false,
        mostrarMotivoRemocaoTexto: false,
        mostrarMotivo: false,
        motivoTexto: null,
        motivoRemocaoTexto: null,
        motivoTextoState: null,
        motivoRemocaoTextoState: null,
        documento: null,
        documentoAtr: null,
        documentoAtrState: null
      }
    }
  },
  computed: {
    beneficiaria () {
      return this.$store.state.usuario.minhaBeneficiaria
    },
    justificativas () {
      return this.$store.state.atendimento.justificativas
    },
    motivos () {
      return this.$store.state.atendimento.motivos
    },
    motivosRemocao () {
      return this.$store.state.atendimento.motivosRemocao
    },
    atendimentos () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    }
  },
  methods: {
    permiteConfirmacao: function (data) {
      let specificDate = new Date(data)
      let currentDate = new Date()
      if (currentDate.getTime() > specificDate.getTime()) {
        return true
      } else {
        return false
      }
    },
    permiteAnexarDocumento: function (data, atendimento) {
      if (atendimento.imagem_anexada) {
        return false
      } else {
        if (this.verificarDiferencaDias(data) <= 3) {
          return true
        } else {
          return false
        }
      }
    },
    verificarDiferencaDias (dt1) {
      const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
      const firstDate = new Date(dt1)
      const secondDate = new Date()

      return Math.round(Math.abs((firstDate - secondDate) / oneDay)) + 1
    },
    permiteCancelamento: function (data, atendimento) {
      let specificDate = new Date(data)
      let currentDate = new Date()

      if (currentDate.getTime() > specificDate.getTime()) {
        return false
      } else {
        if (atendimento.realizado !== 'CANCELADO') {
          if (this.verificarDiferencaDias(data) > 1) {
            return true
          }
        }
        return false
      }
    },
    permiteAvaliarCancelamento: function (data, atendimento) {
      if (atendimento.realizado === 'SIM') {
        return false
      }

      // let specificDate = new Date(data)
      // let currentDate = new Date()
      // if (currentDate.getTime() > specificDate.getTime()) {
      if (atendimento.imagem_anexada && (atendimento.situacao !== 'APROVADO')) {
        return true
        // }
      } else {
        return false
      }
    },
    fecharModal () {      
      this.modalDesfazerVinculo = false
    },
    confirmarEncontro: function (id) {
      Vue.http.post('api/voluntario/definirEncontro', {atendimento_id: id, realizado: 'SIM', 'situacao': 'APROVADO'}).then(response => {
        this.$store.dispatch('getRegistros', {resource: this.resource, limit: this.totalPorPagina, filtros: {beneficiaria: this.$route.params.id}})
      }).catch(e => {
        let response = e.body

        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error(response.msg, 'Ops!', 9000)
      })
    },
    encontroNaoRealizado: function (id) {
      this.$bvModal.msgBoxConfirm('Você confirma que o atendimento NÃO foi realizado? Caso confirme, uma penalidade será aplicada à beneficiária.', {
        okTitle: 'Confirmo!',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loadingNaoComparecer = true
          Vue.http.post('api/voluntario/definirEncontro', {atendimento_id: id, realizado: 'NAO', 'situacao': 'APROVADO'}).then(response => {
            this.loadingNaoComparecer = false
            this.$store.dispatch('getRegistros', {resource: this.resource, limit: this.totalPorPagina, filtros: {beneficiaria: this.$route.params.id}})
          }).catch(e => {
            let response = e.body
            this.loadingNaoComparecer = false
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error(response.msg, 'Ops!', 9000)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    avaliarCancelamento: function (id, justificativa, imagem) {
      this.modalAvaliarJustificativa = true
      this.id = id
      this.justificativa = justificativa
      this.imagemJustificativa = imagem
    },
    formatDate (criadoEm) {
      let date = new Date(criadoEm)

      let day = date.getDate()
      let month = (date.getMonth() + 1)

      if (month < 10) {
        month = '0' + month
      }

      if (day < 9) {
        day = '0' + (day + 1)
      } else {
        day = day + 1
      }

      return day + '/' + month + '/' + date.getFullYear()
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    navigate (route) {
      this.$router.push(route)
    },
    desfazerVinculo: function () {
      this.modalDesfazerVinculo = true
    },
    rejeitarJustificativa: function () {
      this.rejeitar = true

      if (!this.justificativaVoluntario) {
        this.justificativaVoluntarioState = false
        return false
      }

      let data = {
        atendimento_id: this.id,
        justificativa_reprovacao: this.justificativaVoluntario,
        situacao: 'REPROVADO',
        realizado: 'CANCELADO'
      }

      Vue.http.post('api/voluntario/avaliarCancelamentoBeneficiaria', data).then(response => {
        this.modalAvaliarJustificativa = false
        this.$store.dispatch('getRegistros', {resource: this.resource, limit: this.totalPorPagina, filtros: {beneficiaria: this.$route.params.id}})
      }).catch(e => {
        let response = e.body

        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error(response.msg, 'Ops!', 9000)
      })
    },
    aprovarJustificativa: function () {
      this.rejeitar = false

      let data = {
        atendimento_id: this.id,
        situacao: 'APROVADO',
        realizado: 'CANCELADO'
      }

      Vue.http.post('api/voluntario/avaliarCancelamentoBeneficiaria', data).then(response => {
        this.modalAvaliarJustificativa = false
        this.$store.dispatch('getRegistros', {resource: this.resource, limit: this.totalPorPagina, filtros: {beneficiaria: this.$route.params.id}})
      }).catch(e => {
        let response = e.body

        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error(response.msg, 'Ops!', 9000)
      })
    },
    cancelarAntecedencia: function (id) {
      this.modalCancelarAntecedencia = true
      this.id = id
    },
    efetivarCancelamento () {
      if (this.validarFormCancelamento()) {
        let data = {
          atendimento_id: this.id,
          justificativa: this.cancelar.justificativa,
          imagem: this.cancelar.documento
        }

        if (this.cancelar.justificativa === 'BCJ' || this.cancelar.justificativa === 'VCJ') {
          data.motivo = this.cancelar.motivo

          if (parseInt(this.cancelar.motivo) === 4) {
            data.justificativa_texto = this.cancelar.motivoTexto
          }
        }

        this.loadingCancelar = true
        Vue.http.post('api/voluntario/cancelarAtendimento', data).then(response => {
          this.loadingCancelar = false
          this.limparForm()
          this.$store.dispatch('getRegistros', {resource: this.resource, limit: this.totalPorPagina, filtros: {beneficiaria: this.$route.params.id}})
        }).catch(e => {
          let response = e.body
          this.loadingCancelar = false
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.msg, 'Ops!', 9000)
        })
      }
    },
    efetivarRemocao () {
      if (this.validarFormRemocao()) {
        let data = {
          beneficiaria_id: parseInt(this.$route.params.id),
          voluntario_id: parseInt(SessionStorage.get('usuario')),
          motivo: parseInt(this.cancelar.motivoRemocao),
          justificativa: this.cancelar.motivoRemocaoTexto
        }

        this.loadingCancelar = true
        Vue.http.post('api/voluntario/desfazerVinculo', data).then(response => {

          if (response.body.success) {
            this.loadingCancelar = false
            this.limparForm()
            this.$store.dispatch('getRegistros', {resource: this.resource, limit: this.totalPorPagina, filtros: {beneficiaria: this.$route.params.id}})
            miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
            miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            this.$router.push('/beneficiarias')
          } else {
            this.loadingCancelar = false
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error(response.body.msg, 'Alerta', 5000)
          }
        }).catch(e => {
          let response = e.body
          this.loadingCancelar = false
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.msg, 'Ops!', 9000)
        })
      }
    },
    limparForm () {
      this.modalCancelarAntecedencia = false
      this.cancelar.justificativa = null
      this.cancelar.justificativaState = null
      this.cancelar.motivo = null
      this.cancelar.motivoRemocao = null
      this.cancelar.motivoState = null
      this.cancelar.motivoRemocaoState = null
      this.cancelar.mostrarMotivoTexto = false
      this.cancelar.mostrarMotivoRemocaoTexto = false
      this.cancelar.mostrarMotivo = false
      this.cancelar.motivoTexto = null
      this.cancelar.motivoRemocaoTexto = null
      this.cancelar.motivoTextoState = null
      this.cancelar.documento = null
    },
    validarFormCancelamento () {
      let valid = true

      if (!this.cancelar.justificativa) {
        valid = false
        this.cancelar.justificativaState = false
      } else {
        this.cancelar.justificativaState = true
      }

      if (this.cancelar.justificativa === 'BCJ' || this.cancelar.justificativa === 'VCJ') {
        if (!this.cancelar.motivo) {
          valid = false
          this.cancelar.motivoState = false
        } else {
          this.cancelar.motivoState = true

          if (parseInt(this.cancelar.motivo) === 4) {
            if (!this.cancelar.motivoTexto) {
              valid = false
              this.cancelar.motivoTextoState = false
            } else {
              this.cancelar.motivoTextoState = true
            }
          }
        }
      }

      return valid
    },
    validarFormRemocao () {
      let valid = true

      if (!this.cancelar.motivoRemocao) {
        valid = false
        this.cancelar.motivoRemocaoState = false
      } else {
        this.cancelar.motivoRemocaoState = true

        if (parseInt(this.cancelar.motivoRemocao) === 3) {
          if (!this.cancelar.motivoRemocaoTexto) {
            valid = false
            this.cancelar.motivoRemocaoTextoState = false
          } else {
            this.cancelar.motivoRemocaoTextoState = true
          }
        }
      }

      return valid
    },
    uploadDocumento (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.cancelar.documento = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    uploadDocumentoAtr (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.cancelar.documentoAtr = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    anexarDocumentoJustificativa (id) {
      this.modalDocumentoJustificativa = true
      this.id = id
    },
    enviarDocumentoAtr () {
      if (!this.cancelar.documentoAtr) {
        this.cancelar.documentoAtrState = false
        return false
      }

      let data = {
        atendimento_id: this.id,
        imagem_anexada: this.cancelar.documentoAtr,
        tipo: 'VOLUNTARIO'
      }

      Vue.http.post('api/voluntario/informarDocumento', data).then(response => {
        this.modalDocumentoJustificativa = false
        this.cancelar.documentoAtrState = null
        miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
        miniToastr.success('Imagem anexada com sucesso!', 'Sucesso!', 7000)
        this.$store.dispatch('getRegistros', {resource: this.resource, limit: this.totalPorPagina, filtros: {beneficiaria: this.$route.params.id}})
      })
    }
  }
}
</script>

<style scoped>
    .action{
        cursor: pointer;
    }
    img.preview {
        width: 350px;
        background-color: white;
        border: 1px solid #DDD;
        padding: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/voluntario/VisualizarBeneficiaria.vue